import Api from 'portal-modules/ledger/api'
import { call, takeLatest, put } from 'redux-saga/effects'
import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
const REQUEST_INVOICE = 'rp/ledger/REQUEST_INVOICE'
const RECEIVE_INVOICE = 'rp/ledger/RECEIVE_INVOICE'
const RESET_INVOICE = 'rp/ledger/RESET_INVOICE'
// reducer
export default function customerInvoice(state = {}, { type, payload }) {
  switch (type) {
    case RECEIVE_INVOICE:
      return { ...state, ...payload }
    case CHANGE_USER_ACCOUNT:
    case RESET_INVOICE:
    case LOGOUT:
      return {}
    default:
      return state
  }
}
// action creators
export const requestInvoice = () => ({ type: REQUEST_INVOICE })
export const resetInvoice = () => ({ type: RESET_INVOICE })
export const receiveInvoice = payload => ({
  type: RECEIVE_INVOICE,
  payload,
})

// sagas
export function* fetchInvoices() {
  const { invoices } = yield call(Api.getCustomerInvoices)
  yield invoices && put(receiveInvoice(invoices))
}

function* watchRequestInvoice() {
  yield takeLatest(
    REQUEST_INVOICE,
    createRequestSaga(fetchInvoices, {
      key: 'payments',
      message: __('Looking for transactions'),
    }),
  )
}

export const sagas = [watchRequestInvoice]
